import PortalAppService from "../../../application/platform/portal-app-service";
import { ACTION_TYPES, useOfficialDailyDetailDispatch } from "./official-daily-detail-context";

export const useOfficialDailyDetailController = () => {
    const dispatch = useOfficialDailyDetailDispatch();

    async function loadDetail(id: number) {
        try {
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: true });
            const detail = await PortalAppService.getOfficialDailyDetail(id);
            dispatch({ type: ACTION_TYPES.SET_OFFICIAL_DAILY_DETAIL, payload: detail });
        } catch (error) {
            console.error('Error loading official daily detail:', error);
            dispatch({ type: ACTION_TYPES.SET_ERROR, payload: 'Erro ao carregar detalhes do diário oficial' });
        }
    }

    return {
        loadDetail
    };
};
